import { jsx as _jsx } from "react/jsx-runtime";
import { TableRow, Typography } from '@mui/material';
import { memo } from 'react';
import * as S from '../../styles';
export const DetailsLabel = memo(function DetailsLabel(props) {
    const { label } = props;
    return (_jsx(TableRow, { children: _jsx(S.LabelCell, { colSpan: 2, children: _jsx(Typography, { textAlign: "left", width: "100%", fontWeight: "bold", children: label }) }) }));
});
